// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconModalClose: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path
                fill="currentColor"
                d="M13.6557781,12.2123488 C14.0657137,12.6211763 14.0657137,13.2844916 13.6557781,13.693363 C13.2458424,14.1022343 12.580729,14.1021904 12.1707493,13.693363 L7.00071404,8.49890447 L1.79392515,13.6916171 C1.38398883,14.1004446 0.718876067,14.1004446 0.308896349,13.6916171 C-0.101083369,13.2827897 -0.101039973,12.6194744 0.308896349,12.210603 L5.51743513,7.01963618 L0.307452241,1.78765116 C-0.10248408,1.37882375 -0.10248408,0.715508407 0.307452241,0.306637044 C0.717388563,-0.10223432 1.38250133,-0.102190375 1.79248104,0.306637044 L7.00071404,5.54036788 L12.2075029,0.347655216 C12.6174386,-0.061172202 13.282552,-0.061172202 13.6925317,0.347655216 C14.1025115,0.756482635 14.1024674,1.41979797 13.6925317,1.82866934 L8.48399229,7.01963618 L13.6557781,12.2123488 Z"
            />
        </svg>
    );
};

export default React.memo(IconModalClose);
